export default {
  methods: {
    formatUser: user => {
      const tmp = user;
      tmp.display_name = `${user.first_name} ${user.last_name}`;
      return tmp;
    },
    sortUsers: (a, b) => a.display_name.toLowerCase().localeCompare(b.display_name.toLowerCase()),
    resolveUsers(arr) {
      return arr.map(this.formatUser).sort(this.sortUsers);
    },
  },
};
